import axios from 'axios';
import { Message } from 'element-ui';
import base from './base';


import router from "@/router"
// let token = ""
let isReloginShow = 0
// 创建一个 axios 实例
const service = axios.create({
    baseURL: `${base.bd}`, // 所有的请求地址前缀部分
    timeout: 60000, // 请求超时时间毫秒
    withCredentials: false, // 异步请求携带cookie
    maxRedirects: 5, // 允许最多5次重定向
    headers: {
        // 设置后端需要的传参类型
        // 'Content-Type': 'application/json',
        'Authorization': '',
        // 'X-Requested-With': 'XMLHttpRequest',
    },
})

// 添加请求拦截器
service.interceptors.request.use(
    function (config) {
        console.log(config);
        // 在发送请求之前做些什么
        // token = window.localStorage.getItem('token')
        const token = window.localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        //添加租户id
        if(window.localStorage.getItem('tenantId')){
            config.headers['tenant-id'] = window.localStorage.getItem('tenantId') // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config
    },
    function (error) {
        // 对请求错误做些什么
        console.log(error)
        return Promise.reject(error)
    }
)

// 添加响应拦截器
service.interceptors.response.use(
    function (response) {
        console.log('Response:', response)
        console.log('Response status:', response.status)
        console.log('Response headers:', response.headers)
        // 2xx 范围内的状态码都会触发该函数。
        // 对响应数据做点什么
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data
        if (dataAxios.code == 401 || dataAxios.code == 403) {
            // autoToken 登录流程中不清除 token、不跳转登录页，由 router 处理跳转
            if (window.__autoTokenLogin) {
                return Promise.reject(response);
            }
            Message({
                message: dataAxios.msg,
                type: "warning"
            });
            localStorage.clear()
            router.push(
                {
                    path: "/login"
                }
            )

        }
        if (response?.data?.message?.code == 201) {
            // autoToken 登录流程中不清除 token、不跳转登录页
            if (window.__autoTokenLogin) {
                return Promise.reject(response);
            }
            if (isReloginShow == 0) {
                isReloginShow++
                Message({
                    message: '登录状态已过期，请重新登录',
                    type: "warning"
                });
                // location.href = '#/login'

                // isReloginShow = 0
                localStorage.clear()
                router.push(
                    {
                        path: "/login"
                    }
                )
            }
        }
        // 这个状态码是和后端约定的
        // const code = dataAxios.reset
        return dataAxios
    },
    function (error) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        console.log(error)
        return Promise.reject(error)
    }
)

export default service
